import React from 'react';
import { Helmet } from 'react-helmet';
import { useAuth } from '../../contexts/AuthContext';
import RoleBasedNavigation from '../../components/navigation/RoleBasedNavigation';
import HeroSection from './components/HeroSection';
import BenefitsSection from './components/BenefitsSection';
import FeaturesShowcase from './components/FeaturesShowcase';
import PlaysShowcase from './components/PlaysShowcase';
import TestimonialsSection from './components/TestimonialsSection';
import FoundersSection from './components/FoundersSection';
import PerformersSection from './components/PerformersSection';
import CTASection from './components/CTASection';
import FooterSection from './components/FooterSection';

const LandingPage = () => {
  const { user, userProfile, isAuthenticated } = useAuth();

  return (
    <>
      <Helmet>
        <title>BardPlay - Master Shakespeare Like Never Before</title>
        <meta name="description" content="Transform Shakespeare from struggle to mastery with gamified learning, performance tools, and squad collaboration. Join students crushing their English classes." />
      </Helmet>
      
      <div className="min-h-screen bg-gradient-to-br from-background via-surface-dark to-background">
        <RoleBasedNavigation 
          user={{
            ...user,
            role: userProfile?.role,
            full_name: userProfile?.full_name,
            email: user?.email
          }} 
          isAuthenticated={isAuthenticated} 
        />
        
        <main className="main-content pt-16">
          <HeroSection />
          <section id="benefits">
            <BenefitsSection />
          </section>
          <section id="features">
            <FeaturesShowcase />
          </section>
          <section id="plays">
            <PlaysShowcase />
          </section>
          <section id="testimonials">
            <TestimonialsSection />
          </section>
          <section id="founders">
            <FoundersSection />
          </section>
          <section id="performers">
            <PerformersSection />
          </section>
          <CTASection />
          <FooterSection />
        </main>
      </div>
    </>
  );
};

export default LandingPage;